import { Card, CardContent } from "@/components/ui/card";
import { AlertCircle } from "lucide-react";
import { useLocation } from "react-router-dom";
import { useTranslation } from 'react-i18next';

const supportedLangs = [
  'cs','sv','hu','el','ms','id','nl','ro','uk','pl','th','fa','ur','ta','vi','it','tr','ko','jv','de','ja','ru','bn','pt','hi','fr','ar','zh','es','en'
];

export default function NotFound() {
  const { t } = useTranslation();
  const location = useLocation();
  const pathLang = location.pathname.split('/')[1];
  const isLang404 = pathLang && !supportedLangs.includes(pathLang);

  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-gray-50">
      <Card className="w-full max-w-md mx-4">
        <CardContent className="pt-6">
          <div className="flex mb-4 gap-2">
            <AlertCircle className="h-8 w-8 text-red-500" />
            <h1 className="text-2xl font-bold text-gray-900">{t('notFound.title', '404 Page Not Found')}</h1>
          </div>

          <p className="mt-4 text-sm text-gray-600">
            {isLang404 ? (
              <>
                {t('notFound.langNotSupported', 'The language code')} <b>{pathLang}</b> {t('notFound.langNotSupported2', 'is not supported.')}<br />
                <a href="/en/" className="text-blue-600 underline">{t('notFound.goToHome', 'Go to English Home Page')}</a>
              </>
            ) : (
              <>{t('notFound.routerError', 'Did you forget to add the page to the router?')}</>
            )}
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
